import React from 'react'
import fail from '../../assets/student_registration/close.png'
function Registration_failed() {
  return (
    <section>
    <div className=" d-flex justify-content-center align-items-center vh-100">
        <div className="payment-fail-card p-3  text-center" >
                <img src={fail} alt="fail"  width="80px" height="80px" className='my-3' style={{opacity:'0.7'}}/>
                <h3 style={{color:'#db6a76'}} className='mb-4'>Registration Failed</h3>
                <hr className='my-4' style={{borderTop: '3px dashed red'}}/>
                <div className="content ">
                   <p className='payment-fail-text'> Registration failed due  to some technical issue.
                   <br/>Please contact your counselor or  
                   <a className="text-decoration-none payment-fail-text" href="tel:+91 994724433"> +91 9947144333</a></p>

                 

                   <button className='btn btn-outline-primary my-3 reg-fail-home-btn'
                   onClick={()=>{ window.location.href='https://aspireitacademy.in/';}}
                   >Home</button>
                </div>
               
        </div>
    </div>
</section>
  )
}

export default Registration_failed